import { useT } from '@/i18n';

// "हिं / EN" pill toggle for top bars.
export default function LanguageToggle({ className = '' }) {
  const { lang, setLang } = useT();
  const opt = (v, label) => (
    <button type="button" onClick={() => setLang(v)}
      className={`px-2.5 min-h-[32px] min-w-[36px] text-xs font-semibold rounded-full transition-colors ${lang === v ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-200'}`}
      aria-pressed={lang === v} data-testid={`lang-${v}`}>
      {label}
    </button>
  );
  return (
    <div className={`inline-flex items-center gap-0.5 rounded-full border bg-white p-0.5 ${className}`} data-testid="language-toggle" title="Language / भाषा">
      {opt('hi', 'हिं')}
      {opt('en', 'EN')}
    </div>
  );
}
